// Attach the device's teacher identity (X-Teacher-Id) to every /api/teacher/classes* request.
// The server now requires it for class members / mastery / gaps / exceptions (child learning data).
const LS_TEACHER = "we_teacher_identity_v1";
export function teacherIdFromDevice() {
  try { return JSON.parse(localStorage.getItem(LS_TEACHER) || "null")?.teacher_id || ""; } catch { return ""; }
}
if (typeof window !== "undefined" && window.fetch && !window.__mwqTeacherFetch) {
  const orig = window.fetch.bind(window);
  window.__mwqTeacherFetch = true;
  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === "string" ? input : input?.url || "";
      if (url.includes("/api/teacher/classes") || url.includes("/api/classes/")) {
        const tid = teacherIdFromDevice();
        const h = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined) || {});
        if (tid && !h.has("X-Teacher-Id")) h.set("X-Teacher-Id", tid);
        return orig(input, { ...init, headers: h });
      }
    } catch { /* fall through */ }
    return orig(input, init);
  };
}
